import React from 'react';

const EmailList = ({ emails, selectedEmail, onEmailSelect, loading, folder }) => {
  // Function to strip HTML tags from email body
  const stripHtml = (html) => {
    if (!html) return '';
    
    // First, replace common HTML tags that should create line breaks
    let text = html
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<\/div>/gi, '\n')
      .replace(/<\/li>/gi, '\n');
    
    // Create a temporary element to strip remaining HTML
    const tmp = document.createElement("DIV");
    tmp.innerHTML = text;
    
    // Get the text content
    const result = tmp.textContent || tmp.innerText || "";
    
    // Clean up excessive whitespace and trim
    return result
      .replace(/\n\s*\n\s*\n/g, '\n\n') // Replace 3+ newlines with 2
      .replace(/[ \t]+/g, ' ') // Replace multiple spaces/tabs with single space
      .trim();
  };

  const formatDate = (date) => {
    const emailDate = new Date(date);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    
    if (emailDate.toDateString() === today.toDateString()) {
      return emailDate.toLocaleTimeString('pt-BR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      });
    } else if (emailDate.toDateString() === yesterday.toDateString()) {
      return 'Ontem';
    } else if (emailDate.getFullYear() === today.getFullYear()) {
      return emailDate.toLocaleDateString('pt-BR', { 
        day: 'numeric', 
        month: 'short' 
      });
    } else {
      return emailDate.toLocaleDateString('pt-BR', { 
        day: 'numeric', 
        month: 'short',
        year: 'numeric'
      });
    }
  };

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const formatEmailPreview = (htmlBody) => {
    // Strip HTML and get plain text
    const plainText = stripHtml(htmlBody || '');
    
    // Split by any type of line break
    const lines = plainText
      .split(/[\r\n]+/)
      .map(line => line.trim())
      .filter(line => line.length > 0);
    
    if (lines.length === 0) return '';
    
    // For single line emails
    if (lines.length === 1) {
      return lines[0].length > 120 ? lines[0].substring(0, 117) + '...' : lines[0];
    }
    
    // For multi-line emails, combine first two lines with a space
    const firstLine = lines[0];
    const secondLine = lines[1];
    const preview = `${firstLine} ${secondLine}`;
    
    // Add ellipsis logic
    if (preview.length > 120) {
      return preview.substring(0, 117) + '...';
    } else if (lines.length > 2) {
      return preview + '...';
    } else {
      return preview;
    }
  };

  if (loading) {
    return (
      <div className="email-list loading">
        <div className="loading-spinner">
          <i className="fas fa-spinner fa-spin"></i>
          <p>Carregando emails...</p>
        </div>
      </div>
    );
  }

  if (emails.length === 0) {
    return (
      <div className="email-list empty">
        <div className="empty-state">
          <i className="fas fa-inbox fa-3x"></i>
          <p>Nenhum email encontrado</p>
        </div>
      </div>
    );
  }

  return (
    <div className="email-list">
      {emails.map(email => (
        <div
          key={email._id}
          className={`email-item ${selectedEmail?._id === email._id ? 'selected' : ''} ${!email.read ? 'unread' : ''}`}
          onClick={() => onEmailSelect(email)}
        >
          <div className="email-checkbox">
            <input type="checkbox" onClick={(e) => e.stopPropagation()} />
          </div>
          
          <div className="email-star" onClick={(e) => e.stopPropagation()}>
            <i className={`${email.starred ? 'fas' : 'far'} fa-star`}></i>
          </div>
          
          <div className="email-importance" onClick={(e) => e.stopPropagation()}>
            <i className={`${email.important ? 'fas' : 'far'} fa-bookmark`}></i>
          </div>
          
          <div className="email-content-preview">
            <div className="email-header-info">
              <span className="email-from">
                {folder === 'sent' ? `Para: ${email.to}` : email.from}
              </span>
              {email.attachments && email.attachments.length > 0 && (
                <i className="fas fa-paperclip attachment-icon"></i>
              )}
              <span className="email-date">{formatDate(email.date)}</span>
            </div>
            
            <div className="email-subject">
              {truncateText(email.subject || '(sem assunto)', 100)}
            </div>
            
            <div className="email-preview">
              {formatEmailPreview(email.body)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EmailList;